import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "emp-more-page" }
const _hoisted_2 = { class: "page-content" }
const _hoisted_3 = { class: "profile-avatar" }
const _hoisted_4 = { class: "profile-info" }
const _hoisted_5 = { class: "profile-name" }
const _hoisted_6 = { class: "profile-job" }
const _hoisted_7 = { class: "menu-group" }
const _hoisted_8 = { class: "menu-list" }
const _hoisted_9 = {
  class: "menu-icon",
  style: {"background":"#e3f2fd"}
}
const _hoisted_10 = { class: "menu-content" }
const _hoisted_11 = {
  key: 0,
  class: "menu-badge"
}
const _hoisted_12 = { class: "menu-group" }
const _hoisted_13 = { class: "menu-list" }
const _hoisted_14 = {
  class: "menu-icon",
  style: {"background":"#f3e8ff"}
}
const _hoisted_15 = {
  class: "menu-icon",
  style: {"background":"#f1f5f9"}
}
const _hoisted_16 = { class: "menu-group" }
const _hoisted_17 = { class: "menu-list" }
const _hoisted_18 = {
  class: "menu-icon",
  style: {"background":"#fee2e2"}
}
const _hoisted_19 = { class: "dialog-content" }
const _hoisted_20 = { class: "dialog-actions" }

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpMore',
  setup(__props) {

const store = useStore();
const router = useRouter();

// 사원 정보
const pwaUser = computed(() => store.getters['pwa/pwaUser']);
const userName = computed(() => pwaUser.value?.display_name || pwaUser.value?.emp_name || '사원');
const userJob = computed(() => pwaUser.value?.emp_job || '-');
const sisulName = computed(() => pwaUser.value?.sisul_name || pwaUser.value?.m_sisul_name || '-');

// 공지사항 개수
const noticeCount = ref(0);

// 로그아웃 다이얼로그
const showLogoutDialog = ref(false);

// 공지사항 개수 로드
const loadNoticeCount = async () => {
  try {
    const response = await axios.get('/api/notice/list', {
      params: { page: 1, limit: 1 },
      withCredentials: true
    });
    
    if (response.data.success) {
      // 3일 이내 공지사항 개수 (NEW 표시된 것)
      const notices = response.data.notices || [];
      const threeDaysAgo = Date.now() - (3 * 24 * 60 * 60 * 1000);
      noticeCount.value = notices.filter((n: any) => new Date(n.nc_wdate).getTime() > threeDaysAgo).length;
    }
  } catch (error) {
    console.error('공지사항 로드 오류:', error);
  }
};

const navigateTo = (path: string) => {
  router.push(path);
};

const handleLogout = () => {
  showLogoutDialog.value = true;
};

const confirmLogout = async () => {
  showLogoutDialog.value = false;
  await store.dispatch('pwa/performPwaLogout');
  router.push('/pwa/login');
};

onMounted(() => {
  loadNoticeCount();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "app-header" }, [
      _createElementVNode("div", { class: "header-title" }, "더보기")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "profile-card",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo('/emp/myinfo')))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_icon, {
            size: "36",
            color: "white"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("mdi-account", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(userName.value), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(userJob.value) + " · " + _toDisplayString(sisulName.value), 1)
        ]),
        _createVNode(_component_v_icon, {
          color: "#9ca3af",
          size: "20"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("mdi-chevron-right", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "group-title" }, "메뉴", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "menu-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateTo('/emp/notice')))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_v_icon, {
                size: "20",
                color: "#1976d2"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-bullhorn", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "menu-label" }, "공지사항", -1)),
              (noticeCount.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(noticeCount.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_v_icon, {
              color: "#d1d5db",
              size: "18"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("mdi-chevron-right", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "group-title" }, "계정", -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "menu-item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateTo('/emp/myinfo')))
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_v_icon, {
                size: "20",
                color: "#7c3aed"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-account-circle", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "menu-content" }, [
              _createElementVNode("span", { class: "menu-label" }, "내 정보")
            ], -1)),
            _createVNode(_component_v_icon, {
              color: "#d1d5db",
              size: "18"
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("mdi-chevron-right", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: "menu-item",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateTo('/emp/settings')))
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_v_icon, {
                size: "20",
                color: "#64748b"
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode("mdi-cog", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "menu-content" }, [
              _createElementVNode("span", { class: "menu-label" }, "설정")
            ], -1)),
            _createVNode(_component_v_icon, {
              color: "#d1d5db",
              size: "18"
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode("mdi-chevron-right", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", {
            class: "menu-item logout",
            onClick: handleLogout
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_v_icon, {
                size: "20",
                color: "#dc2626"
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createTextVNode("mdi-logout", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "menu-content" }, [
              _createElementVNode("span", { class: "menu-label logout-text" }, "로그아웃")
            ], -1))
          ])
        ])
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "version-info" }, [
        _createElementVNode("span", null, "버전 1.0.0")
      ], -1))
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showLogoutDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showLogoutDialog).value = $event)),
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "logout-dialog" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#dc2626"
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode("mdi-logout", -1)
                ]))]),
                _: 1
              }),
              _cache[23] || (_cache[23] = _createElementVNode("h3", null, "로그아웃", -1)),
              _cache[24] || (_cache[24] = _createElementVNode("p", null, "정말 로그아웃 하시겠습니까?", -1))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                class: "cancel-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showLogoutDialog.value = false))
              }, "취소"),
              _createElementVNode("button", {
                class: "confirm-btn",
                onClick: confirmLogout
              }, "확인")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})